import moment from "moment";
import "moment/locale/en-au";

moment.locale("en-AU");
